import _433mhz from './core/433mhz.svg';
import _868mhz from './core/868mhz.svg';
import advancedFlowDisabled from './core/advanced-flow-disabled.svg';
import advancedFlow from './core/advanced-flow.svg';
import antennaWavesLeftRight from './core/antenna-waves-left-right.svg';
import archiveboxFill from './core/archivebox-fill.svg';
import arrowClockwise from './core/arrow-clockwise.svg';
import arrowCounterclockwise from './core/arrow-counterclockwise.svg';
import arrowDoubleCircularRotated from './core/arrow-double-circular-rotated.svg';
import arrowDoubleCircular from './core/arrow-double-circular.svg';
import arrowDoubleSquareRotated from './core/arrow-double-square-rotated.svg';
import arrowDoubleSquare from './core/arrow-double-square.svg';
import arrowDownBold from './core/arrow-down-bold.svg';
import arrowDownToLine from './core/arrow-down-to-line.svg';
import arrowDown from './core/arrow-down.svg';
import arrowInfinite from './core/arrow-infinite.svg';
import arrowLeftArrowRight from './core/arrow-left-arrow-right.svg';
import arrowLeftLineRight from './core/arrow-left-line-right.svg';
import arrowLeft from './core/arrow-left.svg';
import arrowRight from './core/arrow-right.svg';
import arrowUpBold from './core/arrow-up-bold.svg';
import arrowUpDownDiagonalSquare from './core/arrow-up-down-diagonal-square.svg';
import arrowUpDownLeftRight from './core/arrow-up-down-left-right.svg';
import arrowUpToLine from './core/arrow-up-to-line.svg';
import arrowUp from './core/arrow-up.svg';
import attachment from './core/attachment.svg';
import auto from './core/auto.svg';
import backward from './core/backward.svg';
import batteryPowerBolt from './core/battery-power-bolt.svg';
import battery from './core/battery.svg';
import bellFill from './core/bell-fill.svg';
import bluetoothDisabled from './core/bluetooth-disabled.svg';
import bluetooth from './core/bluetooth.svg';
import brightnessAuto from './core/brightness-auto.svg';
import brightnessHigh from './core/brightness-high.svg';
import brightnessLow from './core/brightness-low.svg';
import brightnessMedium from './core/brightness-medium.svg';
import calendarStrike from './core/calendar-strike.svg';
import calendar from './core/calendar.svg';
import cameraFill from './core/camera-fill.svg';
import camera from './core/camera.svg';
import car from './core/car.svg';
import cartFill from './core/cart-fill.svg';
import chartBar from './core/chart-bar.svg';
import chartLine from './core/chart-line.svg';
import checkmarkCircleEmpty from './core/checkmark-circle-empty.svg';
import checkmarkCircleFill from './core/checkmark-circle-fill.svg';
import checkmarkCircle from './core/checkmark-circle.svg';
import checkmarkSealFill from './core/checkmark-seal-fill.svg';
import checkmarkSquareEmpty from './core/checkmark-square-empty.svg';
import checkmarkSquareFill from './core/checkmark-square-fill.svg';
import checkmark from './core/checkmark.svg';
import chevronDownBold from './core/chevron-down-bold.svg';
import chevronDownRegular from './core/chevron-down-regular.svg';
import chevronLeftBold from './core/chevron-left-bold.svg';
import chevronLeftRegular from './core/chevron-left-regular.svg';
import chevronRightBold from './core/chevron-right-bold.svg';
import chevronRightRegular from './core/chevron-right-regular.svg';
import chevronUpBold from './core/chevron-up-bold.svg';
import chevronUpRegular from './core/chevron-up-regular.svg';
import chevronUpdown from './core/chevron-updown.svg';
import clockArrowCounterclockwise from './core/clock-arrow-counterclockwise.svg';
import clockFill from './core/clock-fill.svg';
import clock from './core/clock.svg';
import cloudArrowDownFill from './core/cloud-arrow-down-fill.svg';
import cloudArrowDown from './core/cloud-arrow-down.svg';
import cloudArrowUp from './core/cloud-arrow-up.svg';
import cloudDisabled from './core/cloud-disabled.svg';
import cloudFillDisabled from './core/cloud-fill-disabled.svg';
import cloudFill from './core/cloud-fill.svg';
import cloud from './core/cloud.svg';
import command from './core/command.svg';
import createBackup from './core/create-backup.svg';
import creditCard from './core/credit-card.svg';
import crossCircle from './core/cross-circle.svg';
import cross from './core/cross.svg';
import cube from './core/cube.svg';
import desktopcomputer from './core/desktopcomputer.svg';
import dice from './core/dice.svg';
import docker from './core/docker.svg';
import doorArrowRight from './core/door-arrow-right.svg';
import dotWavesLeftRight from './core/dot-waves-left-right.svg';
import dotWavesToprightBottomleft from './core/dot-waves-topright-bottomleft.svg';
import dot from './core/dot.svg';
import electricityBolt from './core/electricity-bolt.svg';
import elipse from './core/elipse.svg';
import empty from './core/empty.svg';
import ethernet from './core/ethernet.svg';
import evCharger from './core/ev-charger.svg';
import exclamationmarkCircleFill from './core/exclamationmark-circle-fill.svg';
import exclamationmarkPolygon from './core/exclamationmark-polygon.svg';
import exclamationmarkTriangleFill from './core/exclamationmark-triangle-fill.svg';
import expand from './core/expand.svg';
import eyeDisabled from './core/eye-disabled.svg';
import eye from './core/eye.svg';
import facebook from './core/facebook.svg';
import flame from './core/flame.svg';
import flowDisabled from './core/flow-disabled.svg';
import flow from './core/flow.svg';
import folderFill from './core/folder-fill.svg';
import formula from './core/formula.svg';
import forward from './core/forward.svg';
import gearFill from './core/gear-fill.svg';
import globe from './core/globe.svg';
import heartFill from './core/heart-fill.svg';
import heartOutline from './core/heart-outline.svg';
import hourglass from './core/hourglass.svg';
import houseArrowDown from './core/house-arrow-down.svg';
import infoCircleFill from './core/info-circle-fill.svg';
import instagram from './core/instagram.svg';
import lgThinqOnHubBold from './core/lg-thinq-on-hub-bold.svg';
import lightbulb from './core/lightbulb.svg';
import link from './core/link.svg';
import linkedin from './core/linkedin.svg';
import linux from './core/linux.svg';
import list from './core/list.svg';
import locationDisabled from './core/location-disabled.svg';
import lock from './core/lock.svg';
import macos from './core/macos.svg';
import magnifyingglass from './core/magnifyingglass.svg';
import mail from './core/mail.svg';
import markerFill from './core/marker-fill.svg';
import micDisabledFill from './core/mic-disabled-fill.svg';
import micFill from './core/mic-fill.svg';
import microphone from './core/microphone.svg';
import minusCircleFill from './core/minus-circle-fill.svg';
import minusCircle from './core/minus-circle.svg';
import minusMedium from './core/minus-medium.svg';
import monetaryPrice from './core/monetary-price.svg';
import moonCircle from './core/moon-circle.svg';
import moon from './core/moon.svg';
import mouseButtonLeft from './core/mouse-button-left.svg';
import nas from './core/nas.svg';
import nearbyDevices from './core/nearby-devices.svg';
import nfc from './core/nfc.svg';
import noSignal from './core/no-signal.svg';
import nosign from './core/nosign.svg';
import option from './core/option.svg';
import paperAirplane from './core/paper-airplane.svg';
import paper from './core/paper.svg';
import pauseCircleFill from './core/pause-circle-fill.svg';
import pauseCircle from './core/pause-circle.svg';
import pause from './core/pause.svg';
import pen from './core/pen.svg';
import percentage from './core/percentage.svg';
import personFill from './core/person-fill.svg';
import personGroupFill from './core/person-group-fill.svg';
import phoneAlert from './core/phone-alert.svg';
import phone from './core/phone.svg';
import playCircle from './core/play-circle.svg';
import play from './core/play.svg';
import plusCircleFill from './core/plus-circle-fill.svg';
import plusCircle from './core/plus-circle.svg';
import plusMedium from './core/plus-medium.svg';
import plusSquareDashed from './core/plus-square-dashed.svg';
import plusSquareFill from './core/plus-square-fill.svg';
import plusSquareRegular from './core/plus-square-regular.svg';
import plusSquare from './core/plus-square.svg';
import proxmox from './core/proxmox.svg';
import qnap from './core/qnap.svg';
import quadRectangles from './core/quad-rectangles.svg';
import questionmarkCircleFill from './core/questionmark-circle-fill.svg';
import questionmarkSmall from './core/questionmark-small.svg';
import raspberryPi from './core/raspberry-pi.svg';
import rectangleDoubleRow from './core/rectangle-double-row.svg';
import rectanglePen from './core/rectangle-pen.svg';
import rectanglePortraitArrowLeft from './core/rectangle-portrait-arrow-left.svg';
import rectanglePortraitArrowRight from './core/rectangle-portrait-arrow-right.svg';
import rectangleRow from './core/rectangle-row.svg';
import restoreBackup from './core/restore-backup.svg';
import rowGrid from './core/row-grid.svg';
import save from './core/save.svg';
import shieldFill from './core/shield-fill.svg';
import shield from './core/shield.svg';
import signal from './core/signal.svg';
import sliderHorizontalFill from './core/slider-horizontal-fill.svg';
import sliderHorizontal from './core/slider-horizontal.svg';
import softwareUpdate from './core/software-update.svg';
import spinner from './core/spinner.svg';
import squareArrowUpRight from './core/square-arrow-up-right.svg';
import squareArrowUp from './core/square-arrow-up.svg';
import squareCross from './core/square-cross.svg';
import squareDoubleRow from './core/square-double-row.svg';
import squareFilledOnSquare from './core/square-filled-on-square.svg';
import squareGrid from './core/square-grid.svg';
import squareOnSquareArrow from './core/square-on-square-arrow.svg';
import squareOnSquare from './core/square-on-square.svg';
import squareRow from './core/square-row.svg';
import squareStackedPlus from './core/square-stacked-plus.svg';
import squaresGridPlus from './core/squares-grid-plus.svg';
import squaresOutline from './core/squares-outline.svg';
import squares from './core/squares.svg';
import starFill from './core/star-fill.svg';
import starsBrush from './core/stars-brush.svg';
import stars from './core/stars.svg';
import stop from './core/stop.svg';
import storage from './core/storage.svg';
import sunArrowDown from './core/sun-arrow-down.svg';
import sunArrowUp from './core/sun-arrow-up.svg';
import sunFillBig from './core/sun-fill-big.svg';
import sunFillSmall from './core/sun-fill-small.svg';
import sun from './core/sun.svg';
import synology from './core/synology.svg';
import tablet from './core/tablet.svg';
import tagFill from './core/tag-fill.svg';
import terminal from './core/terminal.svg';
import thumbsUp from './core/thumbs-up.svg';
import translation from './core/translation.svg';
import trashFill from './core/trash-fill.svg';
import trashLinesFill from './core/trash-lines-fill.svg';
import triangleDown from './core/triangle-down.svg';
import triangleLeft from './core/triangle-left.svg';
import triangleRight from './core/triangle-right.svg';
import triangleSmallUpDown from './core/triangle-small-up-down.svg';
import triangleUp from './core/triangle-up.svg';
import tripleDot from './core/triple-dot.svg';
import truc from './core/truc.svg';
import truenas from './core/truenas.svg';
import unraid from './core/unraid.svg';
import waterDroplet from './core/water-droplet.svg';
import wifi from './core/wifi.svg';
import windows from './core/windows.svg';
import wrench from './core/wrench.svg';
import x from './core/x.svg';
import youtube from './core/youtube.svg';

export const core = {
  _433mhz,
  _868mhz,
  advancedFlowDisabled,
  advancedFlow,
  antennaWavesLeftRight,
  archiveboxFill,
  arrowClockwise,
  arrowCounterclockwise,
  arrowDoubleCircularRotated,
  arrowDoubleCircular,
  arrowDoubleSquareRotated,
  arrowDoubleSquare,
  arrowDownToLine,
  arrowDown,
  arrowDownBold,
  arrowInfinite,
  arrowLeftArrowRight,
  arrowLeftLineRight,
  arrowLeft,
  arrowRight,
  arrowUpDownDiagonalSquare,
  arrowUpDownLeftRight,
  arrowUpToLine,
  arrowUp,
  arrowUpBold,
  attachment,
  auto,
  backward,
  batteryPowerBolt,
  battery,
  bellFill,
  bluetoothDisabled,
  bluetooth,
  brightnessAuto,
  brightnessHigh,
  brightnessLow,
  brightnessMedium,
  calendarStrike,
  calendar,
  cameraFill,
  camera,
  car,
  cartFill,
  chartBar,
  chartLine,
  checkmarkCircleEmpty,
  checkmarkCircleFill,
  checkmarkCircle,
  checkmarkSealFill,
  checkmarkSquareEmpty,
  checkmarkSquareFill,
  checkmark,
  chevronDownBold,
  chevronDownRegular,
  chevronLeftBold,
  chevronLeftRegular,
  chevronRightBold,
  chevronRightRegular,
  chevronUpBold,
  chevronUpRegular,
  chevronUpdown,
  clockArrowCounterclockwise,
  clockFill,
  clock,
  cloudArrowDownFill,
  cloudArrowDown,
  cloudArrowUp,
  cloudDisabled,
  cloudFillDisabled,
  cloudFill,
  cloud,
  command,
  createBackup,
  creditCard,
  crossCircle,
  cross,
  cube,
  desktopcomputer,
  dice,
  docker,
  doorArrowRight,
  dotWavesLeftRight,
  dotWavesToprightBottomleft,
  dot,
  electricityBolt,
  elipse,
  empty,
  ethernet,
  evCharger,
  exclamationmarkCircleFill,
  exclamationmarkPolygon,
  exclamationmarkTriangleFill,
  expand,
  eyeDisabled,
  eye,
  facebook,
  flame,
  flowDisabled,
  flow,
  folderFill,
  formula,
  forward,
  gearFill,
  globe,
  heartFill,
  heartOutline,
  hourglass,
  houseArrowDown,
  infoCircleFill,
  instagram,
  lgThinqOnHubBold,
  lightbulb,
  link,
  linkedin,
  linux,
  list,
  locationDisabled,
  lock,
  macos,
  magnifyingglass,
  mail,
  markerFill,
  micDisabledFill,
  micFill,
  microphone,
  minusCircleFill,
  minusCircle,
  minusMedium,
  monetaryPrice,
  moonCircle,
  moon,
  mouseButtonLeft,
  nas,
  nearbyDevices,
  nfc,
  noSignal,
  nosign,
  option,
  paperAirplane,
  paper,
  pauseCircleFill,
  pauseCircle,
  pause,
  pen,
  percentage,
  personFill,
  personGroupFill,
  phoneAlert,
  phone,
  playCircle,
  play,
  plusCircleFill,
  plusCircle,
  plusMedium,
  plusSquareDashed,
  plusSquareFill,
  plusSquareRegular,
  plusSquare,
  proxmox,
  qnap,
  quadRectangles,
  questionmarkCircleFill,
  questionmarkSmall,
  raspberryPi,
  rectangleDoubleRow,
  rectanglePen,
  rectanglePortraitArrowLeft,
  rectanglePortraitArrowRight,
  rectangleRow,
  restoreBackup,
  rowGrid,
  save,
  shieldFill,
  shield,
  signal,
  sliderHorizontalFill,
  sliderHorizontal,
  softwareUpdate,
  spinner,
  squareArrowUpRight,
  squareArrowUp,
  squareCross,
  squareDoubleRow,
  squareFilledOnSquare,
  squareGrid,
  squareOnSquareArrow,
  squareOnSquare,
  squareRow,
  squareStackedPlus,
  squares,
  squaresGridPlus,
  squaresOutline,
  starFill,
  starsBrush,
  stars,
  stop,
  storage,
  sunArrowDown,
  sunArrowUp,
  sunFillBig,
  sunFillSmall,
  sun,
  synology,
  tablet,
  tagFill,
  terminal,
  thumbsUp,
  translation,
  trashFill,
  trashLinesFill,
  triangleDown,
  triangleLeft,
  triangleRight,
  triangleSmallUpDown,
  triangleUp,
  tripleDot,
  truc,
  truenas,
  unraid,
  waterDroplet,
  wifi,
  windows,
  wrench,
  x,
  youtube,
} as const;
